"use client";

/** DB等の取得失敗時に再試行できる画面を表示する。例外本文や秘密情報は出力しない。 */
export default function ErrorPage({
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	return (
		<section data-traffic-exclude style={{ padding: 30, lineHeight: 2 }}>
			<h1>記事を読み込めませんでした</h1>
			<p>少し時間をおいて、もう一度お試しください。</p>
			<button
				onClick={reset}
				type="button"
				style={{ padding: "8px 20px", marginTop: 16, cursor: "pointer" }}
			>
				再読み込み
			</button>
		</section>
	);
}
